import { BfiCustomStore } from '@apply/ui';
import { Item } from 'devextreme-react/tab-panel';
import PrincipalBClientsTable from '../../../tables/PrincipalBClientsTable';

interface IBClientTabParameters {
    title: string;
    selectedTabIndex: number;
    principalId: number;
    bClientsStore: BfiCustomStore;
}

export const BClientTab: React.FC<IBClientTabParameters> = ({ title, selectedTabIndex, principalId, bClientsStore }) => {
    return (
        <Item title={title}>
            <div
                style={{
                    width: '100%',
                    minHeight: '700px',
                }}
            >
                <PrincipalBClientsTable
                    principalId={selectedTabIndex === 3 ? principalId : null}
                    gridStore={bClientsStore}
                />
            </div>
        </Item>
    );
};
